import React, { useState, useEffect } from "react";

import ERP from "../Images/services/ERP.jpg";
import db from "../Images/services/db.jpg";
import ProfessionalService from "../Images/services/professional_service.jpg";
import project from "../Images/services/project.jpg";

import WhoWeAre from "../Common/WhoWeAre";
import whoarewe from "../Images/whoweare.jpg";
import Connect from "../Common/Connect";
import Customer from "../Common/Customer";

import { Container, Row, Col } from "react-bootstrap";

const Home = () => {
  const phrases = [
    "digital transformation services",
    "AWS cloud innovations",
    "NetSuite expertise",
    "Salesforce implementations",
    "reliable database management",
  ];

  const content = [
    "dbAffinity specializes in delivering Remote ERP and Database Management Services tailored to the needs of small and mid-sized businesses, as well as local, state, and federal agencies. Our mission is to optimize IT operations and ensure seamless system performance. By offering focused, reliable solutions, we enable our clients to concentrate on core business objectives—free from day-to-day IT burdens.",
  
    "Our ERP Management Services are designed to support Oracle E-Business applications with comprehensive coverage—from routine maintenance and troubleshooting to system optimization. In Database Management, we oversee the full lifecycle of Oracle and Microsoft SQL Server databases, including initial setup, performance tuning, and data backup strategies to ensure robust security and performance.",
  
    "At dbAffinity, we take a collaborative, team-based approach to IT support. Our experts provide 24/7/365 coverage, acting as an extension of your IT department. This allows your internal teams to focus on innovation and strategy while we handle operational reliability and maintenance. Our model boosts efficiency while aligning technology management with long-term business goals.",
  
    "What sets dbAffinity apart is our commitment to providing remote support while remaining 100% onshore in North America. This ensures unmatched availability, rapid response times, and strict adherence to data security standards. Our proximity also enables cost efficiency without compromising quality—so your ERP and database environments remain optimized, secure, and in expert hands.",
  ];  

  const [currentPhrase, setCurrentPhrase] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % phrases.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (
    <>
      <div className="hero">
        <h1>Optimize your business with</h1>
        <h2 key={currentPhrase}>{phrases[currentPhrase]}</h2>
      </div>

      <WhoWeAre title="Who We Are" content={content} imageSrc={whoarewe} />

      <Customer />

      <Container fluid className="px-4">
        <div className="services">
          <h1>Services We Offer</h1>
          <p></p>
          <Row>
            <Col xs={12} sm={6} md={6} lg={3} className="px-4">
              <div className="service-card">
                <img src={ERP} alt="ERP Management Services" />
                <div className="content">
                  <h3>ERP Management Services</h3>
                  <p>
                    Our ERP management services focus on delivering expert
                    support for Oracle E-Business Applications, ensuring smooth
                    integration and peak performance.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={3} className="px-4">
              <div className="service-card">
                <img src={db} alt="Database Management Services" />
                <div className="content">
                  <h3>Database Management Services</h3>
                  <p>
                    Our database services encompass complete lifecycle
                    management for Oracle and Microsoft SQL Server databases,
                    including setup, tuning, and secure backups.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={3} className="px-4">
              <div className="service-card">
                <img src={ProfessionalService} alt="Professional Services" />
                <div className="content">
                  <h3>Professional Services</h3>
                  <p>
                    We provide staff augmentation and on-site consulting
                    services on a Time and Materials basis to supplement your
                    existing IT team.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={3} className="px-4">
              <div className="service-card">
                <img src={project} alt="Project-Based Services" />
                <div className="content">
                  <h3>Project-Based Services</h3>
                  <p>
                    dbAffinity delivers specialized DBA project support tailored
                    for complex requirements, negotiated and executed on a
                    per-project basis.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Connect />
    </>
  );
};

export default Home;